/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
var o;!function(o){o[o.LayerOnly=0]="LayerOnly",o[o.ColorComposite=1]="ColorComposite",o[o.GridComposite=2]="GridComposite",o[o.COUNT=3]="COUNT"}(o||(o={}));export{o as TileBlendInput};
